

$(function () {

  // banner
  !function () {
    var $banner = $('.home-banner');
    var $item = $('.home-banner .item');
    var $item_1 = $('.home-banner .item-1');
    var $item_2 = $('.home-banner .item-2');
    var $video = $('.home-banner .item-2 video');
    var $dotsLi = null;
    var slick_duration_ms = Array.from($item).map(item => parseInt($(item).css('--slick-duration')))
    var slick_duration_ms = [7000, 6000];
    var timer = null;
    var firstTimer = null;

    // get video height
    var windowResize = debounce(function () {
      $video.height($item_1.height());
    }, 300);
    $(window).on('resize', windowResize).trigger('resize');

    // slick init
    var slickInit = function () {
      $dotsLi = $('.home-banner .slick-dots li');
      $dotsLi.eq(0).addClass('loading');
      slick_duration_ms.forEach(function (item, index) {
        $dotsLi.eq(index).css('--slick-duration', item + 'ms');
        $item.eq(index).attr('data-slick-duration', item);
      });

      // 一次性快速进入视频板块 
      firstTimer = setTimeout(function () {
        $banner.slick('slickGoTo', $item_2.data('slick-index'));
      }, 1800);

      $('.home-banner').on('touchmove mousemove',
        throttle(function () {
          if (!$banner[0].slick.swiping) return;

          $dotsLi.removeClass('loading');
          clearTimeout(timer);
          clearTimeout(firstTimer);
        }, 80, 80)
      );
    };
    var slickBeforeChange = function (event, slick, currentSlide, nextSlide) {
      $dotsLi.removeClass('loading');
      clearTimeout(timer);
      clearTimeout(firstTimer);

      var headerHeight = ($('.announcement-bar-x').height() + $('.header-wrapper').height())
      // 剩余高度
      var rHeight = Math.max(600, window.innerHeight - headerHeight)
      // 高度满屏 减去 头部高度
      var height = Math.min(800 , rHeight)
      console.log("height", height);
      
      $banner.find('.slick-list').height(height)
      $banner.find('.item-2').height(height)
    };
    var slickAfterChange = function (event, slick, currentSlide) {
      $dotsLi.eq(currentSlide).addClass('loading');
      // autoplay timeout
      var t = $item.eq(currentSlide).data('slick-duration');
      timer = setTimeout(function () {
        var targetIndex = currentSlide + 1 >= $item.length ? 0 : currentSlide + 1;
        $banner.slick('slickGoTo', targetIndex);
      }, t);

      if (currentSlide == $item_2.data('slick-index')) {
        $video[0].currentTime = 0;
        $video[0].play();
      }
    };

    // ajax
    var ajaxSuccess = function (data) {
      $banner.on('init', slickInit).on('beforeChange', slickBeforeChange).on('afterChange', slickAfterChange).slick({
        adaptiveHeight: true,
        arrows: false,
        dots: true,
        infinite: false,
        speed: 200,
        touchThreshold: 3,
        // autoplay: true,
        // autoplaySpeed: 5920,
        // pauseOnHover: false,
        // pauseOnFocus: false,
      });
      
      
      var videoBlobSrc = URL.createObjectURL(new Blob([data], { type: 'video\/mp4' }));
      $video.attr('src', videoBlobSrc);
    };
    if (window.innerWidth <= 749){
      var url = $video.data('srcMobile')
       $video.attr('src',url);
        $.ajax({
          url:url,
          xhrFields: { responseType: 'blob' },
          cache: true,
          success: ajaxSuccess,
        });
    }else{
      var url = $video.data('src')
      $.ajax({
        url: url,
        xhrFields: { responseType: 'blob' },
        cache: true,
        success: ajaxSuccess,
      });
    }

  }()



});
